<template>

    <div class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-20">
        <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
        
        <div class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">

            <div class="modal-content py-4 text-left px-6">
                <!--Title-->
                <div class="flex justify-between items-center pb-3">
                <p class="text-2xl font-bold">
                    <slot name="title"></slot>
                </p>
                <div class="modal-close cursor-pointer z-50">
                    <svg @click="$emit('close', false)" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                        <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                    </svg>
                </div>
                </div>

                <!--Body-->
                <p class="mt-2 mb-4">
                    <slot name="body"></slot>
                </p>

                <!--Footer-->
                <div class="flex justify-end pt-2">
                    <button class="btn btn-info" @click="$emit('close', false)">
                        <slot name="cancel">No</slot>
                    </button>
                    <slot name="customButton"></slot>
                    <button v-if="!doNotShowAction" class="btn ml-4" :class="btnClass" @click="closeModal">
                        <div v-if="loading" class="loader"></div>
					    <span v-else><slot name="button"></slot></span>
                    </button>
                </div>
                
            </div>

        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            loading: false
        }
    },

    props: {
        btnClass: String,
        doNotShowAction: Boolean
    },

    methods: {
        closeModal() {
            this.loading = true
            this.$emit('action')
        }
    }
}
</script>
